import { Spinner } from '@studio/design-system/spinner';
import type { ReactElement } from 'react';

/** Select `<Loading>` indicator. */
export const Loading = (): ReactElement => (
  <div className='flex gap-8'>
    <Spinner />
    <span>Loading...</span>
  </div>
);
